import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'appPostalCodeFormat',
    standalone: false
})
export class PostalCodeFormatPipe implements PipeTransform {
    transform(value: string): string {
        const parts = value.match(/^([0-9]{4})\s*([A-Z]{2})/);
        if (!parts) {
            console.error(`Invalid postal code: ${value}`);
            return value;
        }

        return `${parts[1]} ${parts[2]}`;
    }
}
